import type { GTMTag } from '../SendTag';

type GTMDataLayerState = {
  reset: () => void;
};

type GTMDataLayerEntry = GTMTag | ((dataLayer: GTMDataLayerState) => void);

declare global {
  interface Window {
    dataLayer?: GTMDataLayerEntry[];
  }
}

// eslint-disable-next-line consistent-return
export const pushTagGTM = (tag: GTMTag) => {
  if (!globalThis.window.dataLayer) {
    // TODO: Dynatrace or an other logger service should catch this error
    // eslint-disable-next-line no-console
    return console.error('No GTM dataLayer present, tag is not sent');
  }

  globalThis.window.dataLayer.push(
    dataLayer => {
      dataLayer.reset();
    },
    tag
  );
};
